export const TOGGLE_WELCOME_MODAL = 'TOGGLE_WELCOME_MODAL';

export const toggleWelcomeModal = () => ({
  type: TOGGLE_WELCOME_MODAL,
});
